import { useDispatch } from "react-redux";
import { Delete } from "@mui/icons-material";

import { denyEntry } from "../../../actions/entry";
import { AutoProgressButton } from "../forms/fields/AutoProgressButton";
import { T } from "../../util/t";

export const DenyButton = ({ eventDivisionId, entryId, isTeams, closeModal }) => {
    const dispatch = useDispatch();
    const deny = () => dispatch(denyEntry(eventDivisionId, entryId, isTeams)).then(closeModal);

    return (
        <AutoProgressButton className="left" onClick={deny} startIcon={<Delete/>}>
            <T>Cancel entry</T>
        </AutoProgressButton>
    );
};
